export default {
  index: [
    {
      path: '/qytask',
      component: resolve => require(['./qytaskIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qy_task/_router.js